// Generated by purs version 0.15.15
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
var ul = /* #__PURE__ */ Halogen_HTML_Elements.keyed("ul");
var ul_ = /* #__PURE__ */ ul([  ]);
var tr = /* #__PURE__ */ Halogen_HTML_Elements.keyed("tr");
var tr_ = /* #__PURE__ */ tr([  ]);
var thead = /* #__PURE__ */ Halogen_HTML_Elements.keyed("thead");
var thead_ = /* #__PURE__ */ thead([  ]);
var tfoot = /* #__PURE__ */ Halogen_HTML_Elements.keyed("tfoot");
var tfoot_ = /* #__PURE__ */ tfoot([  ]);
var tbody = /* #__PURE__ */ Halogen_HTML_Elements.keyed("tbody");
var tbody_ = /* #__PURE__ */ tbody([  ]);
var table = /* #__PURE__ */ Halogen_HTML_Elements.keyed("table");
var table_ = /* #__PURE__ */ table([  ]);
var ol = /* #__PURE__ */ Halogen_HTML_Elements.keyed("ol");
var ol_ = /* #__PURE__ */ ol([  ]);
var menu = /* #__PURE__ */ Halogen_HTML_Elements.keyed("menu");
var menu_ = /* #__PURE__ */ menu([  ]);
var header = /* #__PURE__ */ Halogen_HTML_Elements.keyed("header");
var header_ = /* #__PURE__ */ header([  ]);
var form = /* #__PURE__ */ Halogen_HTML_Elements.keyed("form");
var form_ = /* #__PURE__ */ form([  ]);
var footer = /* #__PURE__ */ Halogen_HTML_Elements.keyed("footer");
var footer_ = /* #__PURE__ */ footer([  ]);
var fieldset = /* #__PURE__ */ Halogen_HTML_Elements.keyed("fieldset");
var fieldset_ = /* #__PURE__ */ fieldset([  ]);
var dl = /* #__PURE__ */ Halogen_HTML_Elements.keyed("dl");
var dl_ = /* #__PURE__ */ dl([  ]);
var div = /* #__PURE__ */ Halogen_HTML_Elements.keyed("div");
var div_ = /* #__PURE__ */ div([  ]);
var dialog = /* #__PURE__ */ Halogen_HTML_Elements.keyed("dialog");
var dialog_ = /* #__PURE__ */ dialog([  ]);
var colgroup = /* #__PURE__ */ Halogen_HTML_Elements.keyed("colgroup");
var colgroup_ = /* #__PURE__ */ colgroup([  ]);
var article = /* #__PURE__ */ Halogen_HTML_Elements.keyed("article");
var article_ = /* #__PURE__ */ article([  ]);
export {
    article,
    article_,
    colgroup,
    colgroup_,
    dialog,
    dialog_,
    div,
    div_,
    dl,
    dl_,
    fieldset,
    fieldset_,
    footer,
    footer_,
    form,
    form_,
    header,
    header_,
    menu,
    menu_,
    ol,
    ol_,
    table,
    table_,
    tbody,
    tbody_,
    tfoot,
    tfoot_,
    thead,
    thead_,
    tr,
    tr_,
    ul,
    ul_
};
//# sourceMappingURL=index.js.map
